class SizeGuide {
  constructor() {
    this.currentUnit = 'in';
    this.init();
  }

  init() {
    const sizeGuide = document.querySelector('.size-guide-drawer');
    if (!sizeGuide) return;

    const sizeGuideType = sizeGuide.dataset.sizeGuide;
    const data = window.SizeGuideData[sizeGuideType];

    if (!data) {
      console.warn(`Size guide data not found for type: ${sizeGuideType}`);
      return;
    }

    this.renderInstructions(data.instructions);
    this.renderTable(data.data);
    this.bindEvents();
  }

  renderInstructions(instructions) {
    const container = document.querySelector(
      '.size-guide-drawer__instructions'
    );
    if (!container) return;

    container.innerHTML = instructions
      .map(
        (instruction) => `
      <div class="size-guide-drawer__instruction">
        <div class="size-guide-drawer__instruction-title">${instruction.title}</div>
        <div class="size-guide-drawer__instruction-description">${instruction.description}</div>
      </div>
    `
      )
      .join('');
  }

  renderTable(data) {
    const thead = document.querySelector('.size-guide-drawer__table-header');
    const tbody = document.querySelector('.size-guide-drawer__table-body');

    if (!thead || !tbody || !data.length) return;

    // Get all measurement types (excluding Size)
    const measurementTypes = Object.keys(data[0]).filter(
      (key) => key !== 'Size'
    );

    // Render header
    thead.innerHTML = `
      <tr>
        <th>Size</th>
        ${measurementTypes.map((type) => `<th>${type}</th>`).join('')}
      </tr>
    `;

    // Render body
    tbody.innerHTML = data
      .map((row) => {
        const sizeCell =
          typeof row.Size === 'object'
            ? `${row.Size[this.currentUnit]}`
            : row.Size;

        return `
        <tr>
          <td>${sizeCell}</td>
          ${measurementTypes
            .map((type) => {
              if (
                typeof row[type] === 'object' &&
                row[type][this.currentUnit]
              ) {
                return `<td>${row[type][this.currentUnit]}</td>`;
              } else if (typeof row[type] === 'string') {
                return `<td>${row[type]}</td>`;
              } else {
                return `<td>-</td>`;
              }
            })
            .join('')}
        </tr>
      `;
      })
      .join('');
  }

  bindEvents() {
    // Unit toggle
    document.querySelectorAll('.size-guide-drawer__unit').forEach((button) => {
      button.addEventListener('click', (e) => {
        document
          .querySelectorAll('.size-guide-drawer__unit')
          .forEach((btn) =>
            btn.classList.remove('size-guide-drawer__unit--active')
          );
        e.target.classList.add('size-guide-drawer__unit--active');
        this.currentUnit = e.target.dataset.unit;
        this.updateTable();
      });
    });
  }

  updateTable() {
    const sizeGuide = document.querySelector('.size-guide-drawer');
    if (!sizeGuide) return;

    const sizeGuideType = sizeGuide.dataset.sizeGuide;
    const data = window.SizeGuideData[sizeGuideType];

    if (!data) return;

    this.renderTable(data.data);
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new SizeGuide();
});

// Initialize when drawer opens
document.addEventListener('click', (e) => {
  // Check if size guide drawer is being opened
  if (e.target.closest('[aria-controls="Size-Guide-menu-drawer"]')) {
    // Small delay to ensure drawer content is rendered
    setTimeout(() => {
      new SizeGuide();
    }, 100);
  }
});

// Also initialize if the size guide is loaded dynamically
document.addEventListener('size-guide-loaded', () => {
  new SizeGuide();
});
